export default __webpack_public_path__ + "static/media/hht1_ep10_minisitcom_01.a9987b19.png";